import { render, staticRenderFns } from "./dzdak.vue?vue&type=template&id=74b36e49&scoped=true&"
import script from "./dzdak.vue?vue&type=script&lang=js&"
export * from "./dzdak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b36e49",
  null
  
)

export default component.exports